import { Outlet, useLocation } from 'react-router-dom'
import PublicHeader from '../components/layout/PublicHeader.jsx'
import PublicFooter from '../components/layout/PublicFooter.jsx'
import PageHeader from '../components/layout/PageHeader.jsx'
import PageFooter from '../components/layout/PageFooter.jsx'
import { useScrollToTop } from '../hooks/useScrollToTop.js'
import Modal from '../components/common/Modal/Modal.jsx'

export default function PublicLayout() {
    useScrollToTop()
    const location = useLocation()
    const isHomePage = location.pathname === '/'

    return (
        <div className="min-h-screen flex flex-col">
            {isHomePage ? <PublicHeader /> : <PageHeader />}
            <main className="flex-1">
                <Outlet />
            </main>
            {isHomePage ? <PublicFooter /> : <PageFooter />}
            <Modal />
        </div>
    )
}